export default __webpack_public_path__ + "static/media/nft1.3481250e.png";